"use client";
import { useState } from "react";

import PropTypes from "prop-types";

import Button from "components/common/button";

import { phoneFormatter } from "helpers/phone-formatter";

import styles from "./styles.module.css";

const ContactAction = ({ phoneNumber }) => {
  const [isShowPhone, setIsShowPhone] = useState(false);
  const handleShowPhoneButton = (e) => {
    e.preventDefault();
    setIsShowPhone(true);
  };
  return (
    <div className={styles.actionsWrapper}>
      <p className={styles.title}>Detaylı bilgi için bizimle iletişime geç!</p>
      {isShowPhone ? (
        <Button size="M" href={`tel:${phoneNumber}`} className={styles.phoneButton}>
          {phoneFormatter(phoneNumber)}
        </Button>
      ) : (
        <Button size="M" onClick={(e) => handleShowPhoneButton(e)} className={styles.phoneButton}>
          Telefona Bak
        </Button>
      )}
    </div>
  );
};

ContactAction.propTypes = {
  phoneNumber: PropTypes.string,
};

export default ContactAction;
